import type { AdminSection, ContentKind, PropertyType } from "@/lib/types"

export const APP_NAME = "Harbor & Pine Realty"

export const DEMO_CREDENTIALS = {
  member: {
    email: "member@harborpine.demo",
    password: "DemoMember!",
    label: "Member / property owner",
  },
  admin: {
    email: "admin@harborpine.demo",
    password: "DemoAdmin!",
    label: "Administrator",
  },
} as const

export const PROPERTY_TYPES: Array<{ value: PropertyType; label: string }> = [
  { value: "residential", label: "Residential" },
  { value: "commercial", label: "Commercial" },
  { value: "land", label: "Land" },
  { value: "investment", label: "Investment" },
  { value: "holiday-rental", label: "Holiday rental" },
]

export const REGIONS = [
  "North Quay",
  "Cedar Grove",
  "Mariner Ridge",
  "Harborview",
  "Juniper Coast",
] as const

export const DEMO_MEDIA = [
  "/images/properties/dark-timber-house.webp",
  "/images/properties/renovated-cottage.webp",
  "/images/properties/waterfront-apartment.webp",
  "/images/properties/urban-townhouse.webp",
  "/images/properties/family-bungalow.webp",
  "/images/properties/commercial-loft.webp",
  "/images/properties/forest-cabin.webp",
  "/images/properties/coastal-land.webp",
] as const

export const PUBLIC_NAVIGATION = [
  { to: "/search", label: "Buy", search: { transaction: "buy" } },
  { to: "/search", label: "Rent", search: { transaction: "rent" } },
  { to: "/my-listings", label: "Sell" },
  { to: "/search", label: "Properties" },
  { to: "/events", label: "Open houses" },
  { to: "/news", label: "Field notes" },
] as const

export const MEMBER_NAVIGATION = [
  { to: "/dashboard", label: "Overview" },
  { to: "/favorites", label: "Saved properties" },
  { to: "/saved-searches", label: "Saved searches" },
  { to: "/alerts", label: "Alerts" },
  { to: "/my-listings", label: "My listings" },
  { to: "/account", label: "Account" },
] as const

export const ADMIN_SECTIONS: Array<{
  value: AdminSection
  label: string
}> = [
  { value: "properties", label: "Properties" },
  { value: "inquiries", label: "Inquiries" },
  { value: "users", label: "Users & roles" },
  { value: "content", label: "Content" },
  { value: "taxonomies", label: "Taxonomies" },
  { value: "settings", label: "Settings" },
]

export const CONTENT_KINDS: Array<{ value: ContentKind; label: string }> = [
  { value: "news", label: "News" },
  { value: "event", label: "Event" },
  { value: "page", label: "Information page" },
  { value: "faq", label: "FAQ" },
  { value: "team", label: "Team" },
  { value: "testimonial", label: "Testimonial" },
  { value: "partner", label: "Partner" },
  { value: "home", label: "Home content" },
]

export const formatPrice = (
  price: number,
  transaction: "buy" | "rent",
  period?: string | null
) => {
  const formatted = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  }).format(price)

  return transaction === "rent"
    ? `${formatted}${period ? ` / ${period}` : " / month"}`
    : formatted
}

export const titleCase = (value: string) =>
  value
    .split("-")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ")
